export const autoNumOff = 0
export const autoNumOn = 1
export const autoNumManual = 2
export const zforPal = 1
export const zforVirtual = 2
export const redCrossScale = 0.4
export const defaultCanvasWidth = 900
export const defaultCanvasHeight = 650
export const canvasZoom = 1 // 0.5
export const vdzOpacity = 0.3
export const vdzFill = '#2222ff'
export const debugTargetFill = '#00ff00'
export const selectedBorder = '#ff0000'
export const shadowCol = '#888888'
export const boxColor = '#af8d68'
export const boxColorSelected = '#8d7a69'
export const boxBorderColor = '#79634a'
export const tapeColor = '#79634a'
export const groupMarkerColor = '#44382a'
export const labelColor = '#ece1d5'
export const badPlaceColor = '#ff0039'
export const multiPickBorder = '#0000ff'
export const idStrokeColor = '#ffffff'
export const idFillColor = '#ffffff'
export const templatePrefix = 'template.'
export const addTemplateName = 'addTemplate.'
export const addTemplateColor = '#8fd1cb'
export const addTemplateHighlightColor = '#99dbd5'
export const edgeMatchMargin = 15
export const boxLabel = { fontSize: 40, fontWeight: 500 }
export const pusherGroupBorder = '#58D68D'
export const groupBorder = '#5992BA'
export const warningColor = '#ff9900'
export const boxBorderWidth = 12
export const statusGoodColor = '#23AF72'
